import { useContext } from 'react'
import { ImagesListItem, ImagesViewerStateContext } from 'src/contexts'

export const useImagesViewer = (): {
  isOpen: boolean
  currentImageIndex: number
  images: ImagesListItem[]
  setImages: (images: ImagesListItem[]) => void
  openGallery: (images?: ImagesListItem[]) => void
  closeGallery: () => void
} => {
  const {
    isOpen,
    images,
    closeViewer,
    openViewer,
    setImages,
    currentImageIndex,
  } = useContext(ImagesViewerStateContext)
  const openGallery = (imgs?: ImagesListItem[]) => {
    if (Array.isArray(imgs)) {
      setImages(imgs)
    }
    openViewer()
  }

  return {
    isOpen,
    currentImageIndex,
    images,
    setImages,
    openGallery,
    closeGallery: closeViewer,
  }
}
